import React from 'react';
import { useSelector } from 'react-redux';

import { get } from 'lodash';

import { useCheckSessionExpired } from '@lib/hooks';
import { selectCurrentMasterSettings, selectCurrentUser } from '@lib/selectors';

interface Props {
  pathOnExpire: string;
}

const Expiration: React.FC<Props> = ({ pathOnExpire }) => {
  const masterSettings = useSelector(selectCurrentMasterSettings);
  const currentUser = useSelector(selectCurrentUser);

  let minutes = get(masterSettings, 'session.logoutTimeout', 30);

  if (get(currentUser, 'type') === 'doctor' && minutes <= 120) {
    minutes = 120;
  }

  useCheckSessionExpired(minutes, pathOnExpire);

  return null;
};

export default Expiration;
